<template>
  <v-container
    dense
    justify="center"
    class="raison-highlight px-4 py-2"
  >
    <v-row>
      <v-col cols="12">
        <h3>{{ $t('conflict.howDoYouChooseOneOfTheseOptions') }}</h3>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      dense
      class="choice-row"
    > 
      <favorite-option
        shortLabelCode="conflict.chooseDefaultOption"
        answerLabelCode="conflict.iChooseWithoutAdditionalInformation"
        @click="selectAnswer(YES_EXCLUSIVE_AND_UNIQUE)"
        :selected="answerSelected === YES_EXCLUSIVE_AND_UNIQUE"
      />
      <favorite-option
        shortLabelCode="conflict.addContext"
        answerLabelCode="conflict.iChooseByAddingMoreInformation"
        @click="selectAnswer(NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION)"
        :selected="answerSelected === NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION"
      />
      <favorite-option
        v-if="!hideNoIPreferMakingGroups"
        shortLabelCode="conflict.makeGroups"
        answerLabelCode="conflict.iPreferMakingGroups"
        @click="selectAnswer(NO_I_PREFER_MAKING_GROUPS)"
        :selected="answerSelected === NO_I_PREFER_MAKING_GROUPS"
      />
      <favorite-option
        v-if="!hideNoICanNotDecide"
        shortLabelCode="conflict.allAreEqual"
        answerLabelCode="conflict.iCantChooseAllThoseOptionsAreEqual"
        @click="selectAnswer(NO_I_CAN_NOT_DECIDE)"
        :selected="answerSelected === NO_I_CAN_NOT_DECIDE"
      />
    </v-row>
  </v-container>
</template>

<script>
import FavoriteOption from '@/components/conflictResolution/FavoriteOption'
import { POSSIBLE_ANSWSERS } from '@/services/conflicts.js'

export default {
  name: 'FavoriteOptions',
  components: { FavoriteOption },

  props: {
    hideNoIPreferMakingGroups: {
      type: Boolean,
      required: true,
    },
    hideNoICanNotDecide: {
      type: Boolean,
      required: true,
    },
    hideNoSense: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      answerSelected: undefined
    }
  },

  methods: {
    selectAnswer(answer) {
      this.answerSelected = answer
      this.$emit('answerSelected', answer);
    },
  },

  created() {
    this.YES_EXCLUSIVE_AND_UNIQUE = POSSIBLE_ANSWSERS.YES_EXCLUSIVE_AND_UNIQUE
    this.NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION = POSSIBLE_ANSWSERS.NO_BUT_I_CAN_CHOOSE_BY_ADDING_INFORMATION
    this.NO_I_PREFER_MAKING_GROUPS = POSSIBLE_ANSWSERS.NO_I_PREFER_MAKING_GROUPS
    this.NO_I_CAN_NOT_DECIDE = POSSIBLE_ANSWSERS.NO_I_CAN_NOT_DECIDE
  }
};
</script>

<style>
.choice-row {
  display: block;
}
.rai-select-option-card {
  cursor: pointer;
}
</style>
